import { useCallback, useState } from 'react';

export const useFormValidation = () => {
  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(true);

  const validate = useCallback(
    (formData, fieldName) => {
      let tempErrors = { ...errors };
      let isValid = true;

      if (!fieldName) {
        Object.keys(formData).forEach((field) => {
          if (!formData[field]) {
            tempErrors[field] = 'This field is required';
            isValid = false;
          }
        });
      }

      if (fieldName && !formData[fieldName]) {
        tempErrors[fieldName] = 'This field is required';
        isValid = false;
      } else {
        delete tempErrors[fieldName];
      }

      if (formData.email && (fieldName === 'email' || !fieldName)) {
        if (!/\S+@\S+\.\S+/.test(formData.email)) {
          tempErrors.email = 'Email is not valid';
          isValid = false;
        } else {
          delete tempErrors.email;
        }
      }

      if (formData.phoneNumber && (fieldName === 'phoneNumber' || !fieldName)) {
        if (!/^\d{10,15}$/.test(formData.phoneNumber)) {
          tempErrors.phoneNumber =
            'Phone number is not valid (should contain 10-15 digits)';
          isValid = false;
        } else {
          delete tempErrors.phoneNumber;
        }
      }

      if (formData.password && (fieldName === 'password' || !fieldName)) {
        if (formData.password.length < 6) {
          tempErrors.password = 'Password must be at least 6 characters';
          isValid = false;
        } else {
          delete tempErrors.password;
        }
      }

      if (
        formData.confirmPassword &&
        (fieldName === 'confirmPassword' || !fieldName)
      ) {
        if (formData.confirmPassword !== formData.password) {
          tempErrors.confirmPassword = 'Passwords do not match';
          isValid = false;
        } else {
          delete tempErrors.confirmPassword;
        }
      }
      setErrors(tempErrors);
      setIsFormValid(isValid);

      return { isValid, errors };
    },
    [errors]
  );

  return { validationErrors: errors, isFormValid, validate };
};
